import { c as _c } from "react/compiler-runtime";
import { Icon } from 'design-system/client';
import { useLocale } from 'next-intl';
function HiddenAmount() {
  const $ = _c(2);
  const locale = useLocale();
  const shouldShowGermanVersion = locale === "de";
  if (shouldShowGermanVersion) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <><Icon name="heart" /><Icon name="euroSign" /></>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><Icon name="euroSign" /><Icon name="heart" /></>;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export default HiddenAmount;